import React, { useEffect, useState, useRef, useMemo} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";

import ReactTableBuilder from "../../utils/reactTableBuilder";
import poApi from "../../api/poApi";
import masterpackApi from "../../api/masterpackApi";
import palletApi from "../../api/palletApi";
import cameraModelApi from "../../api/cameraModelApi";
import featureSwitchApi from "../../api/featureSwitchApi";


import { getCurrentAuthUser } from "../../utils/authorization";
import { useAppContext } from "../../components/context/appContext"
import { expeditionType } from "../../actions/staticDataList";
import { useReactToPrint } from "react-to-print";
import { Box, Divider, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import BigButton from "../../components/material/bigButton"
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, PrinterTypes } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';
import { Switch } from "react-materialize";
import PalletLabel from '../../components/label/palletLabel';
import { postPrintStandardZebraUsbAsync } from "../../utils/prodlocalhelper";
import { downloadBlob, htmlLabelToBlobImage } from "../../utils/blobImageHelper";
import { KeyboardReturnOutlined, ResetTvOutlined } from "@mui/icons-material";


function NewPallet(props) {
  const { t } = props;
  const [userAuth, setUserAuth] = useState();
  const [poList, setPoList] = useState();
  const [selectedExpeditionType, setSelectedExpeditionType] = useState();
  const [scannerValue, setScannerValue] = useState();
  const [scannerError, setScannerError] = useState();
  const [noMasterpackMoveWarning, setNoMasterpackMoveWarning] = useState(false);
  const [palletConfiguration, setPalletConfiguration] = useState({totalUnits:0,totalMasterpacks:0});
  const [mixedPallet, setMixedPallet] = useState(false);
  const [currentPallet, setCurrentPallet] = useState({totalUnits:0, totalMasterpacks:0, palletBarcode:"", rfidEpc:""});
  const [tableData, setTableData] = useState([]);
  const [specialRemark, setSpecialRemark] = useState("");
  const [palletLabelInfo, setPalletLabelInfo] = useState();
  const [onlyReprint, setOnlyReprint] = useState(false);
  const [rfidActive, setRfidActive] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const appContext = useAppContext();

  let printContentRef = useRef(null);

  
  const expeditionTypeOptions = useMemo(() => {
    return (
      expeditionType?.map(expTy => ({label:expTy.name, value:expTy.id})) ?? []
    );
  }, [expeditionType]);


  useEffect(()=>{
    doInitialLoad();
  },[])

  async function doInitialLoad() {
    const res= await getCurrentAuthUser();
    setUserAuth(res);
    loadPoList(res.plant.netsuiteCmId);

    const rfidFlag = await featureSwitchApi.getFeatureSwitch("manufacturing-rfid");
    setRfidActive(rfidFlag.data.value);
  }

  function loadPoList(currentCmId) {
    return poApi.getOpenPoOnCm(currentCmId).then((result) => {
      if (result.data.status === "success") {
        let pos = result.data.data.pos;
        pos.sort((a, b) =>
          a.tranName > b.tranName ? 1 : b.tranName > a.tranName ? -1 : 0
        );
        setPoList(pos);
      }
    });
  }

  function getPoNameFromId(poId) {
    const currentPo = poList?.find((po)=> po.poId === poId);
    if(currentPo)
      return currentPo?.tranName;
    return poId;
  }

  useEffect(()=>{
    if(mixedPallet)
      appContext.showMessage(t('warning'),t('newPallet.mixedPalletChecked'))
  },[mixedPallet])

  useEffect(() => {
    if(!scannerValue && scannerValue !== "")
    {
      setScannerError("");
      return;
    }
  },[scannerValue])

  useEffect(() =>{
    if(palletLabelInfo){
      printAndResetPallet();
    }
  }, palletLabelInfo)

  useEffect(()=>{
    if(currentPallet.palletBarcode && selectedExpeditionType){
      palletApi.updatePallet(currentPallet.palletBarcode,{
        expeditionType: selectedExpeditionType?.value.toLowerCase()
      }).then((err, res)=>{
        console.log(err, res)
      });   

      if(tableData.length > 1) {
        cameraModelApi.getCameraModel(tableData[0].cameraModel).then((cameraModel) =>{
          findPalletConfiguration(cameraModel, selectedExpeditionType.value);          
        });
      }
    }
    
    
  },[selectedExpeditionType])

  const printAndResetPallet = () => {
    if(appContext.printerStatusRFID !== 'ready' || !rfidActive)
    {
      handlePrint();
      resetPallet();
      if(rfidActive)
        appContext.showMessage(t('warning'), "Printer not ready, switching to browser print.");
      return;
    }

    sendToPrinter().then((result)=>{
        if(!result.rfidEpc) {
          // TODO If its undefined it means we don't have the EPC.. what do we? Flag it
            setOnlyReprint(true);
            throw new Error("Print failed, abort pallet reset!");
        }
        //saveEpcToPallet(currentPallet.palletBarcode ,result.rfidEpc);
     
        resetPallet();
      });

      function resetPallet(){
        setPalletLabelInfo(undefined);
        setCurrentPallet({totalUnits:0, totalMasterpacks:0, palletBarcode:""});
        setSpecialRemark("");
        setTableData([]);
        setOnlyReprint(false);
      }
  }

  const handlePrint = useReactToPrint({
    content: () => printContentRef,
  });

  const sendToPrinter = async () =>{
    try{
      // TODO Show loading animation
      if (!printContentRef) return;
      const blobImage = await htmlLabelToBlobImage(printContentRef);

      const formData = new FormData();
      formData.append("file", blobImage, "label.png");
      formData.append("epc", currentPallet.rfidEpc);
      //downloadBlob(blobImage, "test.png")

      const result = await postPrintStandardZebraUsbAsync(formData);
      if(result.status === 200)
        return result.data;
    }
    catch(ex){
      // Do something?
    }
    finally{
      // TODO Remove loading animation
    }
  }

  function startPallet() {
    palletApi.newPallet().then((res)=>{
      if(res.status === 200){
        setCurrentPallet({
          palletBarcode: res.data.barcode,
          rfidEpc: res.data.rfidEpc,
          totalUnits:0, 
          totalMasterpacks:0
        })
      }
      else{
        appContext.showMessage(t('error'),"An unexpected error happened.")
      }

    })
    .catch((err)=> {
      console.log(err);
      appContext.showMessage(t('error'),"An unexpected error happened.")
    })
  }

  async function closePalletAndPrint() {
    //TODO in later version with tracability and the new masterpack screeen, wE'll be able to avoid calling server for the isPack and numberByPack by just adding them to the model infro on the masterpack
    const models = await Promise.all([...new Set(tableData.map(item => item.masterpack.cameraModel.name ))].map(async (modelName) => {
      const cameraModel = await cameraModelApi.getCameraModel(modelName);
      const masterpackArray = tableData.filter(row => row.masterpack.cameraModel.name === modelName);
      return {
        masterpacks: masterpackArray.length,
        units: masterpackArray.reduce((acc, row) => acc + (cameraModel.data.isPack ? (row.masterpack.items.length / cameraModel.data.numberByPack) : row.masterpack.items.length), 0),
        name: modelName
      };
    }));
    setPalletLabelInfo({
      barcode:currentPallet.palletBarcode,
      totalUnits: currentPallet.totalUnits,
      totalMasterpacks: currentPallet.totalMasterpacks,
      models:models
    })
    
    if(!onlyReprint){
        palletApi.updatePallet(currentPallet.palletBarcode,{
          note:specialRemark,
          status:"readyForFullScan",
          expeditionType: selectedExpeditionType?.value.toLowerCase()
      }).then(()=>{
      });      
    }
    else {
      console.log("Only reprint detected");
      printAndResetPallet();
    }
  }

  function scannerOnKeyDown(e){
    if (e.key === 'Enter') {
      handleScan(e.target.value);
    }
  }

  function isPalletBarcode(scan){
    return /^\d{20}$/.test(scan) || /PL-\d[A-L]\d{3}[A-Z]\d{5}/.test(scan);
  }  

  async function handleScan(scan){
    if(isScanning)
      return;
    try {
      setIsScanning(true);

      if(!scan)
      {
        setScannerError("");
        return;
      }
        
      if(isPalletBarcode(scan) && !(currentPallet.barcode))
        await handlePalletScan(scan)
      else
        await handleMasterpackScan(scan);
    }
    finally{
      setIsScanning(false);
    }
  }

  async function handlePalletScan(scan){
    const result = await palletApi.getPallet(scan);

    await Promise.all(result.data.masterPacks.map(async (mp) => {
      await processMasterpackOnPallet(mp, true)
    }));

    const expeditionType = expeditionTypeOptions.find(expeditionType => expeditionType.value === result.data.expeditionType)
    if(result.data.expeditionType)
      setSelectedExpeditionType(expeditionType);
    
    if(result.data.masterPacks.length>0){
      let cameraModel = await cameraModelApi.getCameraModel(result.data.masterPacks[0].cameraModel.name);
      setTimeout(()=>{
        cameraModelApi.getCameraModel(cameraModel.data.name).then((cameraModel) =>{
          findPalletConfiguration(cameraModel, expeditionType.value);          
        });
      },1500)
    }
    
    setCurrentPallet({
      ...currentPallet,
      palletBarcode: result.data.barcode,
      rfidEpc:result.data.rfidEpc
    });
    setTimeout(()=>{console.log(tableData)}, 5000)
  }

  async function handleMasterpackScan(scan) {
    try{
      if(currentPallet.palletBarcode === '' || !selectedExpeditionType){
        setScannerError("No pallet loaded or no expedition type selected");
        return;
      }

      if(isDeleteMode)
      {
        const row = tableData.find(row => row.masterpackNo === scan);
        const index = tableData.indexOf(row);
        if(index && row){
          removeMasterpack(scan, index);//removeMasterpack(scan, index);
        }
        return;
      }

      const result =  (await masterpackApi.getMasterpackSN(scan)
        .then((res)=>{ return res;})
        .catch((error)=> {console.log(error); return error;})
      );

      if(!result?.data)
      {
        setScannerError(t('newPallet.masterpackNotFound'));
        return;
      }
      const masterpack = result?.data;

      if(!noMasterpackMoveWarning && masterpack.palletBarcode){
        //Show yes/no pop-up
        appContext.showConfirmationMessage(t("warning"),t("newPallet.masterpackOnOtherPallet"), 
          async () => { 
            palletApi.removeMasterpackFromPallet(masterpack.palletBarcode, masterpack.barcode).then(()=>{
              processMasterpackOnPallet(masterpack);
            })
          },
          () => { console.log('Operation canceled!') })
        return;
        //Yes -> Remove from old pallet and then put in new
      }

      await processMasterpackOnPallet(masterpack);
    }
    catch(err){
      console.log('Error', err);
      appContext.showMessage(t('error'),"An unexpected error happened");
    }
    finally{
      resetScan();
    }
    
  }

  //TODO this function I made is super bad, it does way too many things and its hard to understand
  //If someone sees this and has time to split it into different functions... please.
  async function processMasterpackOnPallet(masterpack, isLoadingPallet = false) {
    try {
      let hasWarning = false;
      let warningMessage = "";

      const newTableRow={};
      newTableRow.masterpack = masterpack;
      newTableRow.masterpackNo = masterpack.barcode;
      console.log("MASTER",masterpack)
      newTableRow.cameraModel = masterpack.cameraModel.name;
      console.log("AFTER",masterpack)
      if(masterpack.items.length > 0)
        newTableRow.poId = masterpack.items[0].poNumber;
      else {
        appContext.showMessage(t('error'), t('newPallet.emptyMasterPackError'));
        return;
      }
      let cameraModel = await cameraModelApi.getCameraModel(masterpack.cameraModel.name);
      newTableRow.masterpack.cameraModel = cameraModel.data; //Switch with a more complete cameraModel object
      if(tableData.length > 0)
      {

        if( tableData.find((row)=> row.masterpackNo === masterpack.barcode)){
          appContext.showMessage(t('warning'), t('newPallet.masterpackAlreadyOnPallet'));
          return;
        }

        if(tableData[0].cameraModel !== masterpack.cameraModel.name)
        {
          hasWarning = true;
          warningMessage += t("newPallet.mixedPalletWarningModel", { cameraModel: masterpack.cameraModel.name });
          setSpecialRemark(specialRemark + t("newPallet.mixedPalletWarningModel", { lng: "en", cameraModel: masterpack.cameraModel.name }) + '\n');
        }

        if(masterpack.items.length > 0 && tableData[0].poId !== masterpack.items[0].poNumber)
        {
          hasWarning = true;
          warningMessage += ' ' + t("newPallet.mixedPalletWarningPo", { poId: masterpack.items[0].poNumber });
          setSpecialRemark(specialRemark + t("newPallet.mixedPalletWarningPo", { lng: "en", poId: masterpack.items[0].poNumber }) + '\n')
        }
      }
      else {

        //START FIND PALLET CONFIGURATION
        if(!isLoadingPallet)
          findPalletConfiguration(cameraModel, selectedExpeditionType?.value);
        //END FIND PALLET CONFIGURATION
      }

      if(!mixedPallet && hasWarning)
        appContext.showMessage(t('warning'), warningMessage);

      const addToTotalUnits = cameraModel.data.isPack ? (masterpack.items.length / cameraModel.data.numberByPack) : masterpack.items.length;
      const updatedPallet = {
        ...currentPallet,
        totalUnits: currentPallet.totalUnits + addToTotalUnits,
        totalMasterpacks: currentPallet.totalMasterpacks + 1,
      };

      
      if(palletConfiguration.totalMasterpacks > 0)
      {
        if(updatedPallet.totalMasterpacks >= palletConfiguration.totalMasterpacks){
          let warningMessage = t('newPallet.palletLimitReached');
          if(updatedPallet.totalUnits < palletConfiguration.totalUnits)
            warningMessage += ' '+t('newPallet.palletLimitReachedNotEnoughCamera');

          appContext.showMessage(t('warning'), warningMessage);
        }
      }
      


      let addToPalletResult = { status: 200} ;
      if(!isLoadingPallet)
        addToPalletResult = await palletApi.addMasterpackToPallet(currentPallet.palletBarcode, masterpack.barcode);
      if(addToPalletResult.status === 200){

      //setCurrentPallet(updatedPallet);
        setTableData((prevItems) => {
           const totals = calculateCurrentTotals([newTableRow, ...prevItems]);
           updatedPallet.totalUnits =totals.totalUnits;
           updatedPallet.totalMasterpacks = totals.totalMasterpacks;
           setCurrentPallet(updatedPallet);
          return [newTableRow, ...prevItems]
        });
        
        setScannerError("");
      }
      else{
        appContext.showMessage(t('error'),"An unexpected error happened");
      }
    }
    catch(err){
      console.log('Error', err);
      appContext.showMessage(t('error'),"An unexpected error happened");
    }
    finally{
      resetScan();
    }
  }

  function findPalletConfiguration(cameraModel, expeditionType) {
    let newPalletConfiguration = cameraModel.data?.palletConfigurations?.find((config) =>{
      console.log("EX", expeditionType, config.expeditionType)
      if(config.affectedCm === userAuth.plant.netsuiteCmId && config.expeditionType.toLowerCase() === expeditionType.toLowerCase())
        return true;
      return false;
    })
    if(!newPalletConfiguration)
    {
      newPalletConfiguration = cameraModel.data?.palletConfigurations?.find((config) =>{
        if(config.affectedCm.toString() === "0" && config.expeditionType.toLowerCase() === expeditionType.toLowerCase())
          return true;
        return false;
      })
    }

    if(!newPalletConfiguration )
      appContext.showMessage('warning', t('newPallet.noPalletConfigurationFound',{ cameraModel:cameraModel.data.name, expeditionType:selectedExpeditionType?.label}));
    else {
      setPalletConfiguration({
        totalUnits: newPalletConfiguration.totalUnits,
        totalMasterpacks: parseInt(newPalletConfiguration.totalUnits) / parseInt(newPalletConfiguration.unitsPerMasterpack)
      })
    }
    return newPalletConfiguration;
    
  }

  function calculateCurrentTotals(tableData) {
    
    const totalUnits = tableData.reduce((sum, row) => {
      const isPack = !!row?.masterpack?.cameraModel?.isPack;
      const qty = Number(row?.masterpack?.items.length ?? 0);
      if (!isFinite(qty) || qty < 0) return sum; // guard

      if (!isPack) return sum + qty;

      const n = Number(row?.masterpack?.cameraModel?.numberByPack ?? 0);
      if (n <= 0) return sum; // avoid div by zero / invalid

      return sum + (qty / n);       // keep fractional
      // return sum + Math.floor(qty / n); // or floor to ignore incomplete packs
      // return sum + Math.ceil(qty / n);  // or ceil to count incomplete as one
    }, 0);


    return {totalUnits:totalUnits, totalMasterpacks: tableData.length};
  }

  async function resetScan() {
    setScannerValue("");
    //TODO Set focus if not focused??
  }

  function getPalletConfigurationTotalMasterPacks() {
    if(!palletConfiguration)
      return undefined;

    return parseInt(palletConfiguration.totalUnits) / parseInt(palletConfiguration.unitsPerMasterpack);
  }

  function removeMasterpack(masterpackNo, indexToRemove) {
    palletApi.removeMasterpackFromPallet(currentPallet.palletBarcode, masterpackNo).then(()=>{
      const masterpackRow = tableData.find((row) => row.masterpackNo === masterpackNo);
      if(masterpackRow) {
        setCurrentPallet({
         ...currentPallet,
          palletBarcode: currentPallet.palletBarcode
        });
      }

      setTableData((prevItems) => {
        const totals = calculateCurrentTotals(prevItems.filter((_, index) => index !== indexToRemove));
        setCurrentPallet({...currentPallet, ...totals});
        return prevItems.filter((_, index) => index !== indexToRemove)
      });

      //setTableData((prevItems) => prevItems.filter((_, index) => index !== indexToRemove));
    })
  }

  function onChangeisDeleteMode(e) {
      setIsDeleteMode(e.target.checked);
  }

  const columns = [
    {
      Header: t('dashboard_main.masterpack'),
      accessor: "masterpackNo",
    },
    {
      Header: t('dashboard_main.camera_model'),
      accessor: "cameraModel",
    },
    {
      Header: t('po_detail.po_number'),
      accessor: (row)=>{
        return getPoNameFromId(row.poId);
      },
    },
    {
      Header: t('action'),
      accessor: (row, index)=>{
        return (
          <IconButton variant="contained" color="error" aria-label="delete" onClick={()=>{removeMasterpack(row.masterpackNo, index)}}>
            <DeleteIcon />
          </IconButton>
        );
      },
    }
  ];

  return (
    <>
      <StandardPage
        title={t("newPallet.title")}
        description={t("newPallet.title_desc")}
        showPrinterStatus={false}
        showPrinterRFIDStatus={true}
      >
        <StandardPageTopContent>
          <MuiRow>
            <MuiCol size={{ xs:12, md:6}}>
              <MuiRow spacing={1}>
                <MuiCol size={{ xs:12, md:6}}>
                  <BigButton onClick={startPallet} disabled={!(currentPallet.palletBarcode === '')}>
                    {t("newPallet.startNewPallet")}
                  </BigButton>
                </MuiCol>
                <MuiCol size={{ xs:12, md:6}}>
                <BigButton onClick={closePalletAndPrint} 
                       disabled={currentPallet.palletBarcode === ''}
                      >
                      {t("newPallet.finishPalletAndPrintLabel")}
                      </BigButton>
                </MuiCol>
              </MuiRow>
              <MuiRow>
                <MuiCol size={{ xs:12, md:6}}>
                  <MuiSelect disabled={tableData.length > 0}
                    options={expeditionTypeOptions}
                    placeholder={t("pallet_configuration.expedition_type")}
                    value={expeditionTypeOptions.find(opt => opt.value === selectedExpeditionType?.value) || null}
                    onChange={setSelectedExpeditionType}
                  />
                </MuiCol>
                <MuiCol size={{ xs:12, md:6}}>
                  <MuiCheckbox label={t("newPallet.mixedPallet")}
                    value={mixedPallet}
                    onChange={setMixedPallet} />
                </MuiCol>
              </MuiRow>
            </MuiCol>
            <MuiCol size={{ xs:12, md:6}}>
              <MuiTextArea
                label={t("newPallet.specialRemark")}
                value={specialRemark}
                onChange={setSpecialRemark}
              />
            </MuiCol>
          </MuiRow>
          <Box
            sx={{
              backgroundColor: 'grey.100',
              border: '1px solid grey',
              borderRadius: '8px',
              padding: 2,
              marginTop:1,
              marginBottom:2,
              width: '100%',
            }}>
            <MuiRow spacing={2}>
            <MuiCol size={{xs:12, md:5}}>
                <MuiRow spacing={1}>
                  { currentPallet.palletBarcode === '' ?  
                  <MuiCol size={12}>{t("newPallet.noPallet")}</MuiCol> 
                  :
                  <>
                    <MuiCol size={12}>{t("newPallet.currentPallet",{ palletNumber: currentPallet.palletBarcode})}</MuiCol>
                    <MuiCol size={{ xs:12, md:6}}>
                      <MuiTextField
                        disabled
                        value={currentPallet?.totalUnits}
                        label={t("pallet_configuration.total_units")}
                      />
                    </MuiCol>
                    <MuiCol size={{ xs:12, md:6}}>
                      <MuiTextField disabled
                        value={currentPallet?.totalMasterpacks}
                        label={t("pallet_configuration.total_masterpacks")}/>
                    </MuiCol>
                  </>
                  }
                </MuiRow>
              </MuiCol>
              <MuiCol size={{xs:0, md:1}}/>
              <Divider orientation="vertical" flexItem />
              <MuiCol size={{xs:12, md:5}}>
                <MuiRow spacing={1}>
                  <MuiCol size={12}>{t("newPallet.palletConfiguration")}</MuiCol>
                  <MuiCol size={{ xs:12, md:6}}>
                    <MuiTextField
                      disabled
                      value={palletConfiguration?.totalUnits}
                      label={t("pallet_configuration.total_units")}
                    />
                  </MuiCol>
                  <MuiCol size={{ xs:12, md:6}}>
                    <MuiTextField
                      disabled
                      value={palletConfiguration?.totalMasterpacks}
                      label={t("pallet_configuration.total_masterpacks")}
                    />
                  </MuiCol>
                </MuiRow>
              </MuiCol>
            </MuiRow>
          </Box>
          <MuiRow>
            <MuiCol size={12}>
              <MuiCheckbox label={t("newPallet.ackMasterpackAlreadyOnPallet")}
                    value={noMasterpackMoveWarning}
                    onChange={setNoMasterpackMoveWarning} />
            </MuiCol>
          </MuiRow>
          <MuiRow>
            <MuiCol size={12}>
              <Switch
                id="clearPassTest"
                offLabel="Add masterpack"
                onChange={onChangeisDeleteMode}
                onLabel="Remove masterpack"
                checked={isDeleteMode}
                />
            </MuiCol>
            <MuiCol size={12}>
              <ScannerInput
                // disabled={currentPallet.palletBarcode === '' || !selectedExpeditionType}
                onChange={setScannerValue}
                onKeyDown={scannerOnKeyDown}
                value={scannerValue}
                label={t("newPallet.scanMasterpack")}
                error={scannerError}
              />
            </MuiCol>
          </MuiRow>
        </StandardPageTopContent>
        <StandardPageMainContent>
          <ReactTableBuilder columns={columns} data={tableData} maxRows={9}/>
        </StandardPageMainContent>
      </StandardPage>
      <div className="export-area" ref={el => (printContentRef = el)} display={!palletLabelInfo ?'none':'default'}>
        <PalletLabel palletInfo={palletLabelInfo} />
        {/* {barcode:17385998207795, totalmasterPacks:65} */}
      </div>
    </>
  );
}

NewPallet.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(NewPallet);